import { lazy } from "react";
import RouteGuard from "../routerPermission";

const FeaturedProductsPage = lazy(
  () => import("@/widgets/featured-products/FeaturedProductsPage"),
);

// Storefront merchandising — same gate as the Templates page.
const FeaturedProductsRoutes = {
  path: "featured-products",
  children: [
    {
      index: true,
      element: (
        <RouteGuard resource="store" action="update">
          <FeaturedProductsPage />
        </RouteGuard>
      ),
    },
  ],
};

export default FeaturedProductsRoutes;
